import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormHexagon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-hexagon"><path d="M11.7119 1.55664C11.9254 1.46851 12.1699 1.48327 12.373 1.60058L20.8164 6.47558C21.0485 6.60956 21.1914 6.85705 21.1914 7.125V16.875C21.1914 17.1429 21.0485 17.3904 20.8164 17.5244L12.373 22.3994C12.141 22.5334 11.8551 22.5334 11.623 22.3994L3.17969 17.5244C2.94764 17.3904 2.80469 17.1429 2.80469 16.875V7.125C2.80469 6.85705 2.94764 6.60956 3.17969 6.47558L11.623 1.60058L11.7119 1.55664Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormHexagon;
